// extracted by mini-css-extract-plugin
export default {"viewMyWishListButton":"viewMyWishListButton__0cc827","viewWishListButton":"viewWishListButton__03dffb"};